import { store } from 'redux/store';
import { getSocietyShares } from 'modules/society/api/getSocietyShares';
import { setShares } from 'modules/partners/redux/sharesActions';
import { Share } from 'types';
import { PartnerBookShare } from '../types/PartnerBook';

const mapPartnerBookSharesToShares = (
  partnerBookShares: PartnerBookShare[]
): Share[] =>
  partnerBookShares.map((share) => ({
    ...share,
    partner: share.partner._id,
  }));

export const getSharesByPartner = async (
  partnerIds: string[],
  societyId: string
): Promise<Record<string, PartnerBookShare[]> | null> => {
  try {
    if (!partnerIds?.length || !societyId) return null;

    const partnerShares = (await getSocietyShares({
      societyId,
      items: 5000,
    })) as PartnerBookShare[];

    if (!partnerShares?.length) {
      return null;
    }

    const sharesByPartner = partnerShares.reduce(
      (acc: Record<string, PartnerBookShare[]>, share: PartnerBookShare) => {
        const partnerId = share.partner._id;

        if (!acc[partnerId]) {
          acc[partnerId] = [];
        }

        acc[partnerId].push(share);
        return acc;
      },
      {}
    );

    const sharesToState = mapPartnerBookSharesToShares(partnerShares);
    store.dispatch(setShares(sharesToState));

    return sharesByPartner;
  } catch {
    return null;
  }
};
